import request from '@/utils/http';

const getList = async (params) => request({
  method: 'get',
  url: '/get-noticle-list',
  params,
});

const getInfo = async (id) => request({
  method: 'get',
  url: '/get-noticle-info',
  params: { id },
});

export default {
  getList,
  getInfo,
};
